import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMaintenanceContext } from "@/contexts/MaintenanceContext";

/**
 * Persistent badge shown when post-maintenance banner is dismissed but
 * user still has unsaved drafts. Clicking reopens the return banner.
 * (Story 3.7 Task 4)
 */
export const DraftPersistentBadge: React.FC = () => {
  const { reopenBanner, draftCount } = useMaintenanceContext();

  const label = draftCount > 1 ? `${draftCount} rascunhos disponíveis` : "Rascunho disponível";

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <Button
        variant="outline"
        size="sm"
        onClick={reopenBanner}
        className="gap-1.5 border-amber-300 bg-amber-50 text-amber-700 shadow-md hover:bg-amber-100 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-300 dark:hover:bg-amber-900"
        aria-label="Restaurar rascunho salvo"
      >
        <FileText className="h-4 w-4" />
        {label}
      </Button>
    </div>
  );
};
